export const MeetingState_Expert_EmailVerification = [
    '$scope', function($scope) {
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/consultations/meetingStates/expert/emailVerification.html';
    },
];
